/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymAppointmentsStep_5Aliases {
  AUTOCOMPLETE_LOCATION = 'autocomplete-location',
  FETCH_LOCATION = 'fetch-location',
  FIELD_LOCATION = 'field-location',
  FORM_LOCATION = 'form-location',
  LAYOUT_LOCATION = 'layout-location',
  MAPPER_LOCATION = 'mapper-location',
  PANEL_LOCATION = 'panel-location',
  TEXT_LOCATION = 'text-location',
  TEXT_LOCATION_INSTRUCTION = 'text-location-instruction',
}
export { PseudonymAppointmentsStep_5Aliases };
